<template>
  <div class="md-layout page-review-payment">
    <div class="md-layout-item md-medium-size-100 md-size-100">
      <profile header-color="primary"></profile>
    </div>
    <div
      class="md-layout-item md-small-size-100 md-size-500"
      style="padding-bottom: 24px"
    >
      <payment header-color="primary"></payment>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-50">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title" style="color: white;">
              {{ $t("Order Details") }}
            </h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-100">
              <div>
                <span class="payment-lable">{{ $t("Package") }}:</span>
                <b>{{ packageInfo.title }}</b>
              </div>
              <div>
                <span class="payment-lable">{{ $t("Subtotal") }}:</span>
                <b class="algin-right"
                  >${{ (+packageInfo.price / 100).toFixed(2) }}</b
                >
              </div>
              <div v-if="applicableTax">
                <span class="payment-lable">{{ $t("Tax") }}:</span>
                <b class="algin-right"
                  >${{ applicableTax.toFixed(2) }}</b
                >
              </div>
              <div v-if="totalFee">
                <span class="payment-lable">{{ $t("Total") }}:</span>
                <b class="algin-right"
                  >${{ totalFee.toFixed(2) }}</b
                >
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import { Profile, Payment } from "@/pages";
import { USER_TYPE } from "@/const.js";
import { mapFields } from "vuex-map-fields";
import { taxRate } from "@/helpers/utils";
import { checkUserRoles } from "@/services/flightReview.service.js";

export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {
    Profile,
    Payment
  },
  data() {
    return {
      USER_TYPE: USER_TYPE
    };
  },
  computed: {
    ...mapFields("flightReview", ["packageInfo"]),
    ...mapFields("auth", ["card_last4", "province"]),
    applicableTax() {
      const { taxRates } = taxRate(this.province);
      return (+this.packageInfo.price / 100) * taxRates;
    },
    totalFee() {
      const { taxRates } = taxRate(this.province);
      return (+this.packageInfo.price / 100) * (1 + taxRates);
    }
  },
  methods: {
    async validate() {
      if (!this.card_last4) {
        const { public: public_service } = await checkUserRoles();
        if (public_service) {
          return true
        }
        this.$notify({
          message: this.$t("Please bind your credit card"),
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "warning",
          timeout: 3000
        });
        return;
      }

      return true;
    }
  }
};
</script>

<style lang="css">
.page-review-payment {
  .payment-lable {
    display: inline-block;
    width: 70px;
    text-align: right;
    padding-right: 10px;
  }

  .algin-right {
    width: 52px;
    display: inline-block;
    text-align: right;
  }
}
</style>
